import { useSelector } from 'react-redux';

import { isExisty } from 'utils/helpers.util';
import { IAppState } from 'config/redux/reducers';

const useUser = (): any[] => {
  const { userData: userState } = useSelector(({ userData }: IAppState) => ({
    userData,
  }));
  const isLoggedIn = isExisty(userState.firstName);

  return [isLoggedIn, userState];
};

export default useUser;
